import React from 'react'
import { t } from 'ttag'

import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { CandidateCell } from 'components/shared/Table/common/Cells/CandidateCell/CandidateCell'
import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { JobProgressCell } from 'components/shared/Table/common/Cells/JobProgressCell/JobProgressCell'
import { LanguageCell } from 'components/shared/Table/common/Cells/LanguageCell/LanguageCell'
import { PhoneCell } from 'components/shared/Table/common/Cells/PhoneCell/PhoneCell'
import { Table } from 'components/shared/Table/Table'
import { CandidatesTable } from '../../../CandidatesTable/CandidatesTable'
import { useCandidatesTable } from 'components/pages/Jobs/JobDetails/hooks'
import { getColumns } from './model'
import { HIRE_STATUSES } from '../../../model'
import jobStyles from '../../../JobDetails.module.scss'

const mapSortingPropToQueryParam = {
  created: 'created',
  email: 'email',
  name: 'name',
  status: 'status',
}

export const OverviewTable = ({
  projectId,
  search,
  filter,
  setFilter,
  tab,
  getActions,
  handleFavorite,
  hasInterviewModule,
  active,
}) => {
  const columns = getColumns()

  const {
    state: {
      table: {
        headers,
        model,
        rowSelection,
        isAllRowsSelected,
        isFetching,
        isSomeRowsSelected,
      },
      pagination: { currentPage, pageCount, perPage },
    },
    handlers: {
      table: { toggleAllRowsSelectedHandler },
      pagination: { handlePage, handlePageSize },
    },
  } = useCandidatesTable({
    columns,
    mapSortingPropToQueryParam,
    projectId,
    search,
    filter,
    tab,
  })

  return (
    <CandidatesTable
      {...{
        active,
        headers,
        isAllRowsSelected,
        isFetching,
        isSomeRowsSelected,
        currentPage,
        pageCount,
        perPage,
        toggleAllRowsSelectedHandler,
        handlePage,
        handlePageSize,
        filter,
        setFilter,
      }}
      placeholder={{
        title: t`There are no candidates added to this job`,
        text: t`Click “+ Add candidate“ to continue`,
      }}
    >
      {model.rows.map(
        ({
          id,
          original,
          getIsSelected,
          getIsSomeSelected,
          getToggleSelectedHandler,
        }) => {
          const {
            email,
            language,
            name,
            phone,
            selection_stage,
            status,
            timestamps,
            hire_status,
            is_favourite,
            id: candidateId,
          } = original

          const actions = getActions({ candidate: original })

          return (
            <Table.Row
              key={id}
              type="body"
              onChange={getToggleSelectedHandler()}
              isChecked={getIsSelected()}
              isIndeterminate={getIsSomeSelected()}
              isSelected={rowSelection[id]}
              isHighlighted={hire_status === HIRE_STATUSES.HIRED}
              hasCheckbox
              isDisabled={!active}
              className={jobStyles.row}
            >
              <CandidateCell
                email={email}
                name={name}
                className={active ? jobStyles.favoriteIcon : undefined}
                isFavorite={is_favourite}
                setFavorite={handleFavorite(candidateId)}
                active={active}
                indentIcon
              />
              <PhoneCell phone={phone} />
              <LanguageCell language={language} />
              <DateCell date={timestamps?.created} hasNowLabel />
              <JobProgressCell
                progress={selection_stage - 1}
                status={status}
                type="candidate"
                {...{ hasInterviewModule }}
              />
              <ActionsCell>
                <ActionsDropdown
                  size="medium"
                  isDisabled={!active}
                  {...{ actions }}
                />
              </ActionsCell>
            </Table.Row>
          )
        },
      )}
    </CandidatesTable>
  )
}
